// Runs `start` while `el` is in the viewport and `stop` once it leaves, so a
// looping mockup doesn't keep restarting animations (and forcing reflows) for
// a card the visitor scrolled past or a tab they left. Returns a teardown.
// Without IntersectionObserver the loop just runs.
export default function visibilityLoop(el, { start, stop }) {
  if (!('IntersectionObserver' in window)) {
    start()
    return () => stop()
  }

  let running = false
  const observer = new IntersectionObserver((entries) => {
    const visible = entries.some((entry) => entry.isIntersecting)
    if (visible === running) return
    running = visible
    if (visible) start()
    else stop()
  })
  observer.observe(el)

  return () => {
    observer.disconnect()
    stop()
  }
}
